import React from "react";
import { useTranslation } from "react-i18next";
import { getUserProfilePic, timeClipComment } from "../../helper/GeneralHelper";
import Image from "react-bootstrap/Image";
import { Heart, Reply } from "lucide-react";
import { MultiNumber } from "../MultiNumber";
import AccountVerifyTick from "../AccountVerifyTick";
import DefaultAvatar from "../DefaultAvatar";

const SingleCommentClip = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="comment-user-data"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <DefaultAvatar
          id={props._id}
          userName={props.name}
          width={"32px"}
          height={"32px"}
          className="picture-story"
        >
          {props.profilePicture ? (
            <Image
              className="picture-story"
              width={32}
              height={32}
              title={props.name}
              alt={props.name}
              src={getUserProfilePic(
                props._id,
                props.profilePicture
              )}
            ></Image>
          ) : null}
        </DefaultAvatar>
        <span className="name-comment-creator">
          {props.name}{" "}
          {props?.isCreatorVerified ? (
            <span style={{ marginLeft: "2px", verticalAlign: "text-bottom" }}>
              <AccountVerifyTick width="15px"></AccountVerifyTick>
            </span>
          ) : null}
        </span>
        <span className="clip-pre-url">
          {timeClipComment(props.createdAt, t)}
        </span>
      </div>
      <div className="comment-clip-text">{props.commentText}</div>
      <div className="reply-comment-clip">
        <span className="mr-16px hover">
          <Heart
            size={16}
            style={{ verticalAlign: "text-bottom" }}
            onClick={props.leaveLike}
          />{" "}
          <MultiNumber numberToFix={props.totalCommentReactions} />{" "}
          {t("clip.likes")}
          <div
            className={`emoji-wrap pointer z-index-99 ${
              props.showAddReactionComment && "active"
            }`}
          ></div>
        </span>
        {props.showReply ? (
          <span onClick={props.replyAction} className="hover">
            <Reply size={16} style={{ verticalAlign: "text-bottom" }} />{" "}
            {t("clip.reply")}
          </span>
        ) : null}
      </div>
    </>
  );
};

export default SingleCommentClip;
